import React from 'react';

const FileContext = React.createContext();

export default FileContext;
